import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BusinessOrderStepFormObject} from '../models/business-order-step.models';
import {environment} from '../../../../../environments/environment';

@Injectable({providedIn: 'root'})
export class BusinessOrderStepService {
  constructor(private http: HttpClient) {
  }

  stepStart(
    boId: number,
    boIndex: number,
    ordering: number,
  ): Observable<void> {
    return this.http.post<void>(`${environment.apiv4uri}business/order/${boId}/${boIndex}/step/start/${ordering}`, {});
  }

  stepStop(
    boId: number,
    boIndex: number,
    ordering: number,
    form: BusinessOrderStepFormObject,
  ): Observable<void> {
    return this.http.post<void>(`${environment.apiv4uri}business/order/${boId}/${boIndex}/step/stop/${ordering}`, form);
  }

}
